import { useGDPR } from "@/contexts/GDPR/hooks/useGDPR";
import { getStoredKameleoonConsent } from "@/utils/kameleoon";
import { useEffect } from "react";
import { useKameleoonClient } from "./useKameleoonClient";
export function useKameleoonConsent() {
    const { purposesConsent, consentHasChanged } = useGDPR();
    const CMPConsent = purposesConsent.includes("Kameleoon A/B Testing");
    // read last‐known Kameleoon consent from storage (true/false/null)
    const prevConsent = getStoredKameleoonConsent();
    // only initialize the SDK if they just gave consent, or we already had a stored value
    const shouldInit = CMPConsent || prevConsent !== null;
    // instantiate & initialize SDK when shouldInit flips true
    const { client, visitorCode } = useKameleoonClient(shouldInit);
    // whenever GDPR flips on/off, push into Kameleoon
    useEffect(() => {
        if (!client)
            return;
        if (CMPConsent) {
            client.setLegalConsent(visitorCode, CMPConsent);
            console.warn("[Kameleoon] setLegalConsent:", CMPConsent);
        }
    }, [client, visitorCode, CMPConsent, consentHasChanged]);
}
